import type { GetStaticProps } from 'next'

import { WordPressApiClient } from '@/utils/WordPressApiClient'

import { HomePage } from '@/components/pages/Home'

import type { NewsRelease } from '@/types/newsRelease'

type HomeProps = {
  newsRelease: NewsRelease[]
}

const Home = ({ newsRelease }: HomeProps) => {
  return <HomePage newsRelease={newsRelease} />
}

export const getStaticProps: GetStaticProps = async () => {
  const wpClient = new WordPressApiClient()
  const newsRelease = await wpClient.fetchNewsRelease(3)

  return {
    props: {
      newsRelease,
    },
  }
}

export default Home
